import { gql } from 'graphql-request'

export const CHECK_BOOK_EXIST = gql`
  query CheckBookExist($bookIds: [Int!]!) {
    checkBookExist(bookIds: $bookIds)
  }
`
